import React from "react";
// import ScrollAnimation from "react-animate-on-scroll";

const InfoSection = ({ title, cards }) => {
  return (
    <section className="container mt-30 clearfix">
      <div className="row justify-content-center">
        <div className="col-12 mb-4 mt-4 px-md-5">
          {/* Section Title */}
          {/* <ScrollAnimation animateIn="fadeInRight"> */}
            <h3 className="fw-bold mb-4 text-center" style={{ color: "#091A4E" }}>
              {title}
            </h3>
          {/* </ScrollAnimation> */}

          {/* Cards Grid */}
          <div className="row justify-content-center">
            {cards.map((card, index) => (
              <div className="col-md-6 mb-4" key={index}>
                {/* <ScrollAnimation animateIn="fadeInRight"> */}
                  <div className="card border-2 rounded shadow-sm hover-effect custom-card">
                    <div className="card-body">
                      <h4 className="card-title fw-bold">{card.title}</h4>
                      <p className="card-text">{card.description}</p>
                    </div>
                  </div>
                {/* </ScrollAnimation> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
